// ============================================================================
// CHINESE SIMPLIFIED TRANSLATIONS - CHAPTER 2: 出埃及记
// ============================================================================
// 级别 14-26 (13级别, 39问题)

export const chapter2Translations = {
  name: '出埃及记',
  description: '上帝子民的解放……认识上帝改变我们的生活',
  
  spiritualWisdom: {
    principle: '对上帝的认识能解放和改变人',
    scripture: '你们必晓得真理,真理必叫你们得以自由(约翰福音8:32)',
    application: '正如以色列从埃及得解放,对上帝的认识使我们从属灵的奴役中得自由'
  },
  
  levels: {
    14: {
      name: '摩西从水中获救',
      challenge: '那妇人怀孕,生了一个儿子,见他俊美...',
      easy: {
        question: '摩西的母亲把他藏在什么里面?',
        options: ['山洞', '蒲草箱', '篮子', '房子'],
        hint: '这个容器漂浮在尼罗河上',
        funFact: '🏺 蒲草箱涂了沥青以防水!'
      },
      medium: {
        question: '谁在芦苇中发现了摩西?',
        options: [
          '法老的女儿',
          '埃及女仆',
          '他的姐姐米利暗',
          '埃及祭司'
        ],
        hint: '埃及王室的一员',
        funFact: '👑 具有讽刺意味的是,法老的家人拯救了将挑战他的人!'
      },
      hard: {
        question: '神的护理如何使用我们的敌人?',
        options: [
          '通过使他们改变信仰',
          '通过安排环境来实现祂的旨意',
          '通过惩罚他们',
          '通过忽视他们'
        ],
        hint: '这是关于在事件中看到上帝的手',
        funFact: '✨ 摩西在压迫他族人的人的宫殿中长大!'
      }
    },
    
    15: {
      name: '燃烧的荆棘',
      challenge: '耶和华的使者从荆棘火焰中向他显现...',
      easy: {
        question: '摩西在燃烧的荆棘前应该脱掉什么?',
        options: ['珠宝', '鞋子', '外套', '头巾'],
        hint: '穿在脚上的东西',
        funFact: '👡 脱鞋表达对圣地的尊重!'
      },
      medium: {
        question: '上帝向摩西启示了什么名字?',
        options: [
          '耶和华',
          '自有永有',
          '全能者',
          '造物主'
        ],
        hint: '一个表达绝对存在的名字',
        funFact: '🔥 YHWH(我是)启示了上帝的永恒本质!'
      },
      hard: {
        question: '燃烧却不被烧毁的荆棘教导我们什么?',
        options: [
          '魔法存在',
          '上帝超越自然法则',
          '火是神圣的',
          '植物是神奇的'
        ],
        hint: '这是关于超越我们理解的神性',
        funFact: '🌿 荆棘象征着神的同在能使之成圣而不毁灭!'
      }
    },

    16: {
      name: '埃及的十灾',
      challenge: '法老心里刚硬,不听他们的话...',
      easy: {
        question: '埃及的第一场灾难是什么?',
        options: ['青蛙', '水变成血', '苍蝇', '虱子'],
        hint: '它影响了埃及的生命之源尼罗河',
        funFact: '🩸 尼罗河被当作神来崇拜,上帝显示了祂的优越性!'
      },
      medium: {
        question: '最后也是最可怕的灾难是什么?',
        options: [
          '冰雹',
          '黑暗',
          '长子之死',
          '蝗虫'
        ],
        hint: '这场灾难直接影响了家庭',
        funFact: '😢 这场灾难最终打破了法老的骄傲并释放了以色列!'
      },
      hard: {
        question: '为什么上帝使法老的心刚硬?',
        options: [
          '为了惩罚他',
          '为了彰显祂的荣耀和能力',
          '出于恶意',
          '为了延长苦难'
        ],
        hint: '这是关于显明真神是谁',
        funFact: '⚡ 灾难证明YHWH比所有埃及神都更强大!'
      }
    },

    17: {
      name: '逾越节',
      challenge: '取一只羊羔……把血涂在门楣和门框上...',
      easy: {
        question: '以色列人应该把羊羔的血涂在哪里?',
        options: [
          '衣服上',
          '门楣和门框上',
          '额头上',
          '杯子里'
        ],
        hint: '在房屋的入口处',
        funFact: '🩸 门上的血是神保护的标记!'
      },
      medium: {
        question: '应该如何吃逾越节的羊羔?',
        options: [
          '舒适地坐着',
          '只和家人一起',
          '腰间束带,脚上穿鞋,手中拿杖',
          '沉默中'
        ],
        hint: '准备出发',
        funFact: '🚶 他们必须准备好迅速出发走向自由!'
      },
      hard: {
        question: '逾越节羔羊如何预表基督?',
        options: [
          '通过它的白色',
          '通过替代性牺牲拯救免于死亡',
          '通过它的温顺',
          '通过它的年龄'
        ],
        hint: '这是关于免于定罪的牺牲',
        funFact: '🐑 耶稣被称为除去世人罪孽的上帝的羔羊!'
      }
    },

    18: {
      name: '穿越红海',
      challenge: '摩西向海伸杖...',
      easy: {
        question: '以色列人如何穿越大海?',
        options: [
          '坐船',
          '游泳',
          '走干地',
          '用木筏'
        ],
        hint: '海底变得可以行走',
        funFact: '🌊 上帝把障碍变成了解放之路!'
      },
      medium: {
        question: '追赶的埃及人发生了什么事?',
        options: [
          '他们转身回去',
          '他们被水吞没',
          '他们迷路了',
          '他们加入了以色列'
        ],
        hint: '水回到他们身上',
        funFact: '⚔️ 世界上最强大的军队在瞬间被摧毁!'
      },
      hard: {
        question: '这次穿越在我们的属灵生活中象征什么?',
        options: [
          '逃避问题',
          '从罪的奴役过渡到在上帝里的自由',
          '以色列的优越性',
          '敌人的毁灭'
        ],
        hint: '这是关于属灵的转变',
        funFact: '🗽 红海代表洗礼:向旧事死,新生命!'
      }
    },

    19: {
      name: '旷野的吗哪',
      challenge: '这是什么?因为他们不知道这是什么...',
      easy: {
        question: '吗哪降了多长时间?',
        options: ['10年', '20年', '40年', '50年'],
        hint: '与在旷野的年数相同',
        funFact: '🍞 40年间,上帝奇迹般地喂养了200万人!'
      },
      medium: {
        question: '如果保存吗哪超过一天会发生什么?',
        options: [
          '变得更美味',
          '倍增',
          '腐烂发臭',
          '变硬'
        ],
        hint: '安息日前的星期五除外',
        funFact: '🪱 上帝这样教导人每天依靠祂!'
      },
      hard: {
        question: '吗哪如何教导我们信靠?',
        options: [
          '为将来储备',
          '依靠上帝每日的供应',
          '更努力工作',
          '公平分享'
        ],
        hint: '这是关于每日的信靠',
        funFact: '🙏 我们日用的饮食,今日赐给我们源于这个经历!'
      }
    },

    20: {
      name: '岩石的水',
      challenge: '击打磐石,就有水从其中流出来……',
      easy: {
        question: '摩西应该如何击打磐石?',
        options: ['用手', '用杖', '用脚', '用剑'],
        hint: '上帝给他的工具',
        funFact: '🪨 简单的顺服引发了超自然的奇迹!'
      },
      medium: {
        question: '为什么百姓口渴?',
        options: [
          '因为炎热',
          '因为沙漠中没有水',
          '因为长途旅行',
          '因为疾病'
        ],
        hint: '这是关于他们的环境',
        funFact: '💧 上帝在干旱的沙漠中创造了水源!'
      },
      hard: {
        question: '这磐石如何预表基督?',
        options: [
          '通过它的力量',
          '被击打并给出生命的水',
          '通过它的大小',
          '通过它的位置'
        ],
        hint: '这是关于救恩的源泉',
        funFact: '⚡ 保罗说:那磐石就是基督(哥林多前书10:4)!'
      }
    },

    21: {
      name: '十诫',
      challenge: '上帝吩咐这一切的话说……',
      easy: {
        question: '上帝在哪里赐下十诫?',
        options: ['在埃及', '在西奈山', '在迦南', '在旷野'],
        hint: '有火和烟的圣山',
        funFact: '🔥 上帝的同在使整座山震动!'
      },
      medium: {
        question: '十诫刻在什么上?',
        options: [
          '羊皮纸上',
          '用上帝的指头刻在石板上',
          '木头上',
          '金子上'
        ],
        hint: '永久的材料',
        funFact: '👆 上帝亲自写下祂的律法!'
      },
      hard: {
        question: '律法的目的是什么?',
        options: [
          '拯救人',
          '显明罪并显示上帝的圣洁本性',
          '惩罚人',
          '奴役人'
        ],
        hint: '这是关于显明上帝的标准',
        funFact: '📜 律法引导我们认识需要基督!'
      }
    },

    22: {
      name: '金牛犊',
      challenge: '他们摘下金饰,拿来给亚伦……',
      easy: {
        question: '摩西不在时,百姓做了什么?',
        options: [
          '新帐篷',
          '金牛犊',
          '金纪念碑',
          '新祭坛'
        ],
        hint: '偶像崇拜的对象',
        funFact: '🐄 他们抛弃了解放之神去侍奉偶像!'
      },
      medium: {
        question: '摩西对这罪如何反应?',
        options: [
          '很高兴',
          '发怒并摔碎石板',
          '逃跑',
          '忽视'
        ],
        hint: '他的激烈反应',
        funFact: '😢 当上帝的律法被破坏时,摩西摔碎了律法!'
      },
      hard: {
        question: '为什么人心倾向偶像?',
        options: [
          '因为无知',
          '渴望依靠看得见的东西和对上帝主权的反抗',
          '因为魔鬼的影响',
          '因为软弱'
        ],
        hint: '这是关于人性和对可见之物的渴望',
        funFact: '💔 偶像崇拜用受造物取代造物主!'
      }
    },

    23: {
      name: '会幕',
      challenge: '又当为我造圣所……',
      easy: {
        question: '会幕是什么?',
        options: [
          '宫殿',
          '上帝的移动圣所',
          '仓库',
          '学校'
        ],
        hint: '上帝同在的地方',
        funFact: '⛺ 上帝渴望住在祂子民中间!'
      },
      medium: {
        question: '会幕中最神圣的地方是哪里?',
        options: [
          '祭坛',
          '至圣所',
          '入口',
          '陈设饼桌'
        ],
        hint: '约柜所在的地方',
        funFact: '✨ 只有大祭司一年一次可以进入那里!'
      },
      hard: {
        question: '会幕预表什么?',
        options: [
          '以色列的力量',
          '以马内利,上帝与我们同在,由基督成就',
          '祭司的重要性',
          '仪式的美丽'
        ],
        hint: '这是关于上帝住在人中间',
        funFact: '🙏 耶稣在我们中间搭了帐幕(约翰福音1:14)!'
      }
    },

    24: {
      name: '迦南的探子',
      challenge: '打发人去窥探那地和居民……',
      easy: {
        question: '派了多少探子去窥探迦南?',
        options: ['6个', '10个', '12个', '24个'],
        hint: '以色列每个支派一个',
        funFact: '🕵️ 派了12个,但只有2个有信心!'
      },
      medium: {
        question: '有信心的两个探子是谁?',
        options: [
          '摩西和亚伦',
          '约书亚和迦勒',
          '亚伦和米利暗',
          '基甸和参孙'
        ],
        hint: '活着进入迦南的人',
        funFact: '💪 他们的信心在漂流40年后得到了回报!'
      },
      hard: {
        question: '不信的后果是什么?',
        options: [
          '立即被赦免',
          '在旷野漂流40年',
          '立即受罚',
          '被放逐'
        ],
        hint: '长期的后果',
        funFact: '😢 恐惧使整整一代人失去了进入应许之地!'
      }
    },

    25: {
      name: '铜蛇',
      challenge: '火蛇进入百姓中间,咬他们……',
      easy: {
        question: '咬百姓的是什么蛇?',
        options: ['绿色的', '火蛇', '巨大的', '看不见的'],
        hint: '描述其致命效果的形容词',
        funFact: '🐍 这些蛇象征着罪的致命后果!'
      },
      medium: {
        question: '上帝命令摩西做什么来拯救百姓?',
        options: [
          '制药',
          '在杆上举起铜蛇',
          '祷告',
          '杀死蛇'
        ],
        hint: '信心的行动',
        funFact: '⚕️ 简单的仰望行为就能得救-象征信心!'
      },
      hard: {
        question: '耶稣谈到十字架时如何引用这事件?',
        options: [
          '关于罪的危险',
          '摩西在旷野怎样举蛇,人子也必照样被举起来',
          '关于顺服的必要',
          '关于祷告的能力'
        ],
        hint: '这是关于因信得救',
        funFact: '✝️ 耶稣像铜蛇一样被举起来拯救罪人!'
      }
    },

    26: {
      name: '应许之地',
      challenge: '你可以眼看那地,却不得进去……',
      easy: {
        question: '谁带领以色列过约旦河?',
        options: ['摩西', '亚伦', '约书亚', '迦勒'],
        hint: '摩西的继承人',
        funFact: '🚶 约书亚的名字与耶稣同义:耶和华拯救!'
      },
      medium: {
        question: '为什么摩西不能进入应许之地?',
        options: [
          '太老了',
          '因为在米利巴水边不顺服',
          '拒绝带领百姓',
          '生病了'
        ],
        hint: '以前的特定罪',
        funFact: '😢 即使摩西也面对了不顺服的后果!'
      },
      hard: {
        question: '应许之地象征什么?',
        options: [
          '物质财富',
          '上帝在基督里应许的成就和我们天上的基业',
          '以色列的军事胜利',
          '旷野的结束'
        ],
        hint: '这是关于上帝应许的属灵成就',
        funFact: '🌿 迦南指向等待我们的天上家乡!'
      }
    }
  }
};

export default chapter2Translations;
